import { FormattedMessage } from 'react-intl';

const basePermissionTree = [
    {
        value: 'dashboard',
        label: <FormattedMessage id="menuitems-dashboard-title" />,
        children: [
            {
                value: 'dashboard-default',
                label: <FormattedMessage id="menuitems-dashboard-default-title" />,
                children: [{ value: 'dashboard-default-canView', label: <FormattedMessage id="authkeys-permission-canview" /> }],
                disabled: true
            },
            {
                value: 'dashboard-personal',
                label: <FormattedMessage id="menuitems-dashboard-personal-title" />,
                children: [
                    {
                        value: 'dashboard-personal-kanban',
                        label: <FormattedMessage id="menuitems-dashboard-personal-kanban-title" />,
                        children: [
                            { value: 'dashboard-personal-kanban-canView', label: <FormattedMessage id="authkeys-permission-canview" /> }
                        ]
                    },
                    {
                        value: 'dashboard-personal-calendar',
                        label: <FormattedMessage id="menuitems-dashboard-personal-calendar-title" />,
                        children: [
                            {
                                value: 'dashboard-personal-calendar-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        value: 'workmgmt',
        label: <FormattedMessage id="menuitems-workmgmt-title" />,
        children: [
            {
                value: 'workmgmt-busopp',
                label: <FormattedMessage id="entity-workmgmt-businessopportunity-plural" />,
                children: []
            },
            {
                value: 'workmgmt-workorder',
                label: <FormattedMessage id="entity-workmgmt-workorder-plural" />,
                children: []
            },
            {
                value: 'workmgmt-ticket',
                label: <FormattedMessage id="entity-workmgmt-ticket-plural" />,
                children: [
                    {
                        value: 'workmgmt-ticket-create',
                        label: <FormattedMessage id="menuitems-workmgmt-ticket-create" />,
                        children: [{ value: 'workmgmt-ticket-create-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> }]
                    },
                    {
                        value: 'workmgmt-ticket-list',
                        label: <FormattedMessage id="entity-workmgmt-ticket-plural" />,
                        children: [
                            { value: 'workmgmt-ticket-list-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'workmgmt-ticket-list-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'workmgmt-ticket-list-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'workmgmt-ticket-list-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            {
                                value: 'workmgmt-ticket-list-canCreateLink',
                                label: <FormattedMessage id="authkeys-permission-cancreatelink" />
                            },
                            {
                                value: 'workmgmt-ticket-list-canCopyLink',
                                label: <FormattedMessage id="authkeys-permission-cancopylink" />
                            }
                        ]
                    }
                    // {
                    //     value: 'workmgmt-ticket-listall',
                    //     label: <FormattedMessage id="menuitems-workmgmt-ticket-all" />,
                    //     children: [
                    //         { value: 'workmgmt-ticket-listall-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                    //         {
                    //             value: 'workmgmt-ticket-listall-canDelete',
                    //             label: <FormattedMessage id="authkeys-permission-candelete" />
                    //         },
                    //         {
                    //             value: 'workmgmt-ticket-listall-canRestoreDeleted',
                    //             label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                    //         },
                    //         {
                    //             value: 'workmgmt-ticket-listall-canExport',
                    //             label: <FormattedMessage id="authkeys-permission-canexport" />
                    //         },
                    //         {
                    //             value: 'workmgmt-ticket-listall-canCreateLink',
                    //             label: <FormattedMessage id="authkeys-permission-cancreatelink" />
                    //         },
                    //         {
                    //             value: 'workmgmt-ticket-listall-canCopyLink',
                    //             label: <FormattedMessage id="authkeys-permission-cancopylink" />
                    //         }
                    //     ]
                    // }
                ]
            }
        ]
    },
    {
        value: 'admin',
        label: <FormattedMessage id="menuitems-admin-title" />,
        children: [
            {
                value: 'admin-crm',
                label: <FormattedMessage id="menuitems-admin-crm-title" />,
                children: [
                    {
                        value: 'admin-crm-client',
                        label: <FormattedMessage id="entity-crm-client-plural" />,
                        children: [
                            { value: 'admin-crm-client-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-crm-client-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-crm-client-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'admin-crm-client-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'admin-crm-client-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'admin-crm-client-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            { value: 'admin-crm-client-canImport', label: <FormattedMessage id="authkeys-permission-canimport" /> },
                            {
                                value: 'admin-crm-client-files',
                                label: <FormattedMessage id="entity-media-clientfile-plural" />,
                                children: [
                                    {
                                        value: 'admin-crm-client-files-canAdd',
                                        label: <FormattedMessage id="authkeys-permission-canadd" />
                                    },
                                    {
                                        value: 'admin-crm-client-files-canEdit',
                                        label: <FormattedMessage id="authkeys-permission-canedit" />
                                    },
                                    {
                                        value: 'admin-crm-client-files-canDelete',
                                        label: <FormattedMessage id="authkeys-permission-candelete" />
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        value: 'admin-crm-contract',
                        label: <FormattedMessage id="menuitems-admin-crm-contract-title" />,
                        children: [
                            { value: 'admin-crm-contract-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-crm-contract-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-crm-contract-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'admin-crm-contract-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'admin-crm-contract-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'admin-crm-contract-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> }
                        ]
                    }
                ]
            },
            {
                value: 'admin-hr',
                label: <FormattedMessage id="menuitems-admin-hr-title" />,
                children: [
                    {
                        value: 'admin-hr-department',
                        label: <FormattedMessage id="entity-common-department-plural" />,
                        children: [
                            { value: 'admin-hr-department-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-hr-department-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-hr-department-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'admin-hr-department-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'admin-hr-department-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'admin-hr-department-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            { value: 'admin-hr-department-canImport', label: <FormattedMessage id="authkeys-permission-canimport" /> }
                        ]
                    },
                    {
                        value: 'admin-hr-employee',
                        label: <FormattedMessage id="entity-common-employee-plural" />,
                        children: [
                            { value: 'admin-hr-employee-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-hr-employee-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-hr-employee-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'admin-hr-employee-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'admin-hr-employee-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'admin-hr-employee-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            { value: 'admin-hr-employee-canImport', label: <FormattedMessage id="authkeys-permission-canimport" /> }
                        ]
                    }
                ]
            },
            {
                value: 'admin-tplmgmt',
                label: <FormattedMessage id="menuitems-admin-tplmgmt-title" />,
                children: [
                    {
                        value: 'admin-tplmgmt-busopp',
                        label: <FormattedMessage id="entity-tplmgmt-businessopportunity-plural" />,
                        children: [
                            { value: 'admin-tplmgmt-busopp-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-tplmgmt-busopp-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-tplmgmt-busopp-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'admin-tplmgmt-busopp-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            { value: 'admin-tplmgmt-busopp-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            {
                                value: 'admin-tplmgmt-busopp-tasks',
                                label: <FormattedMessage id="entity-tplmgmt-task-plural" />,
                                children: [
                                    {
                                        value: 'admin-tplmgmt-busopp-tasks-canAdd',
                                        label: <FormattedMessage id="authkeys-permission-canadd" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-busopp-tasks-canView',
                                        label: <FormattedMessage id="authkeys-permission-canview" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-busopp-tasks-canEdit',
                                        label: <FormattedMessage id="authkeys-permission-canedit" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-busopp-tasks-canDelete',
                                        label: <FormattedMessage id="authkeys-permission-candelete" />
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        value: 'admin-tplmgmt-workorder',
                        label: <FormattedMessage id="entity-tplmgmt-workorder-plural" />,
                        children: [
                            { value: 'admin-tplmgmt-workorder-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-tplmgmt-workorder-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-tplmgmt-workorder-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            {
                                value: 'admin-tplmgmt-workorder-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'admin-tplmgmt-workorder-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'admin-tplmgmt-workorder-tasks',
                                label: <FormattedMessage id="entity-tplmgmt-task-plural" />,
                                children: [
                                    {
                                        value: 'admin-tplmgmt-workorder-tasks-canAdd',
                                        label: <FormattedMessage id="authkeys-permission-canadd" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-workorder-tasks-canView',
                                        label: <FormattedMessage id="authkeys-permission-canview" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-workorder-tasks-canEdit',
                                        label: <FormattedMessage id="authkeys-permission-canedit" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-workorder-tasks-canDelete',
                                        label: <FormattedMessage id="authkeys-permission-candelete" />
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        value: 'admin-tplmgmt-followup',
                        label: <FormattedMessage id="entity-tplmgmt-followup-plural" />,
                        children: [
                            { value: 'admin-tplmgmt-followup-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'admin-tplmgmt-followup-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'admin-tplmgmt-followup-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            {
                                value: 'admin-tplmgmt-followup-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'admin-tplmgmt-followup-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'admin-tplmgmt-followup-steps',
                                label: <FormattedMessage id="entity-tplmgmt-followupstep-plural" />,
                                children: [
                                    {
                                        value: 'admin-tplmgmt-followup-steps-canAdd',
                                        label: <FormattedMessage id="authkeys-permission-canadd" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-followup-steps-canView',
                                        label: <FormattedMessage id="authkeys-permission-canview" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-followup-steps-canEdit',
                                        label: <FormattedMessage id="authkeys-permission-canedit" />
                                    },
                                    {
                                        value: 'admin-tplmgmt-followup-steps-canDelete',
                                        label: <FormattedMessage id="authkeys-permission-candelete" />
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        value: 'system',
        label: <FormattedMessage id="menuitems-system-title" />,
        children: [
            {
                value: 'system-nomcltr',
                label: <FormattedMessage id="menuitems-system-nomcltr-title" />,
                children: [
                    {
                        value: 'system-nomcltr-busopptype',
                        label: <FormattedMessage id="entity-workmgmt-businessopportunitytype-plural" />,
                        children: [
                            { value: 'system-nomcltr-busopptype-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            {
                                value: 'system-nomcltr-busopptype-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-nomcltr-busopptype-canEdit',
                                label: <FormattedMessage id="authkeys-permission-canedit" />
                            },
                            {
                                value: 'system-nomcltr-busopptype-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-nomcltr-busopptype-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            {
                                value: 'system-nomcltr-busopptype-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'system-nomcltr-busopptype-canImport',
                                label: <FormattedMessage id="authkeys-permission-canimport" />
                            }
                        ]
                    },
                    {
                        value: 'system-nomcltr-workordertype',
                        label: <FormattedMessage id="entity-workmgmt-workordertype-plural" />,
                        children: [
                            {
                                value: 'system-nomcltr-workordertype-canAdd',
                                label: <FormattedMessage id="authkeys-permission-canadd" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canEdit',
                                label: <FormattedMessage id="authkeys-permission-canedit" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'system-nomcltr-workordertype-canImport',
                                label: <FormattedMessage id="authkeys-permission-canimport" />
                            }
                        ]
                    },
                    {
                        value: 'system-nomcltr-contracttype',
                        label: <FormattedMessage id="entity-crm-contracttype-plural" />,
                        children: [
                            {
                                value: 'system-nomcltr-contracttype-canAdd',
                                label: <FormattedMessage id="authkeys-permission-canadd" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canEdit',
                                label: <FormattedMessage id="authkeys-permission-canedit" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'system-nomcltr-contracttype-canImport',
                                label: <FormattedMessage id="authkeys-permission-canimport" />
                            }
                        ]
                    },
                    {
                        value: 'system-nomcltr-tickettype',
                        label: <FormattedMessage id="entity-workmgmt-tickettype-plural" />,
                        children: [
                            { value: 'system-nomcltr-tickettype-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            {
                                value: 'system-nomcltr-tickettype-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-nomcltr-tickettype-canEdit',
                                label: <FormattedMessage id="authkeys-permission-canedit" />
                            },
                            {
                                value: 'system-nomcltr-tickettype-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-nomcltr-tickettype-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            {
                                value: 'system-nomcltr-tickettype-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'system-nomcltr-tickettype-canImport',
                                label: <FormattedMessage id="authkeys-permission-canimport" />
                            }
                        ]
                    },
                    {
                        value: 'system-nomcltr-partnershiptype',
                        label: <FormattedMessage id="entity-crm-partnershiptype-plural" />,
                        children: [
                            {
                                value: 'system-nomcltr-partnershiptype-canAdd',
                                label: <FormattedMessage id="authkeys-permission-canadd" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canEdit',
                                label: <FormattedMessage id="authkeys-permission-canedit" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            },
                            {
                                value: 'system-nomcltr-partnershiptype-canImport',
                                label: <FormattedMessage id="authkeys-permission-canimport" />
                            }
                        ]
                    }
                ]
            },
            {
                value: 'system-security',
                label: <FormattedMessage id="menuitems-system-security-title" />,
                children: [
                    {
                        value: 'system-security-user',
                        label: <FormattedMessage id="entity-admin-user-plural" />,
                        children: [
                            { value: 'system-security-user-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'system-security-user-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'system-security-user-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            { value: 'system-security-user-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                            {
                                value: 'system-security-user-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'system-security-user-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            { value: 'system-security-user-canImport', label: <FormattedMessage id="authkeys-permission-canimport" /> },
                            { value: 'system-security-user-canLock', label: <FormattedMessage id="authkeys-permission-canlock" /> },
                            { value: 'system-security-user-canUnlock', label: <FormattedMessage id="authkeys-permission-canunlock" /> },
                            {
                                value: 'system-security-user-canApproveUser',
                                label: <FormattedMessage id="authkeys-permission-canapproveuser" />
                            },
                            {
                                value: 'system-security-user-canRejectUser',
                                label: <FormattedMessage id="authkeys-permission-canrejectuser" />
                            },
                            {
                                value: 'system-security-user-canResetPassword',
                                label: <FormattedMessage id="authkeys-permission-canresetpassword" />
                            },
                            {
                                value: 'system-security-user-canDeleteConnections',
                                label: <FormattedMessage id="authkeys-permission-candeleteconnections" />
                            }
                        ]
                    },
                    {
                        value: 'system-security-group',
                        label: <FormattedMessage id="entity-admin-group-plural" />,
                        children: [
                            { value: 'system-security-group-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                            { value: 'system-security-group-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            { value: 'system-security-group-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                            {
                                value: 'system-security-group-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-security-group-canRestoreDeleted',
                                label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                            },
                            { value: 'system-security-group-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> },
                            { value: 'system-security-group-canImport', label: <FormattedMessage id="authkeys-permission-canimport" /> }
                        ]
                    }
                ]
            },
            {
                value: 'system-log',
                label: <FormattedMessage id="menuitems-system-log-title" />,
                children: [
                    {
                        value: 'system-log-busopparchive',
                        label: <FormattedMessage id="entity-log-businessopportunityarchive" />,
                        children: [
                            { value: 'system-log-busopparchive-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                            {
                                value: 'system-log-busopparchive-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-log-busopparchive-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            }
                        ]
                    },
                    {
                        value: 'system-log-workorderarchive',
                        label: <FormattedMessage id="entity-log-workorderarchive" />,
                        children: [
                            {
                                value: 'system-log-workorderarchive-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-log-workorderarchive-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-log-workorderarchive-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            }
                        ]
                    },
                    {
                        value: 'system-log-operation',
                        label: <FormattedMessage id="entity-log-operation" />,
                        children: [
                            {
                                value: 'system-log-operation-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-log-operation-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-log-operation-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            }
                        ]
                    },
                    {
                        value: 'system-log-commandexecution',
                        label: <FormattedMessage id="entity-log-commandexecution" />,
                        children: [
                            {
                                value: 'system-log-commandexecution-canView',
                                label: <FormattedMessage id="authkeys-permission-canview" />
                            },
                            {
                                value: 'system-log-commandexecution-canDelete',
                                label: <FormattedMessage id="authkeys-permission-candelete" />
                            },
                            {
                                value: 'system-log-commandexecution-canExport',
                                label: <FormattedMessage id="authkeys-permission-canexport" />
                            }
                        ]
                    }
                ]
            },
            {
                value: 'system-appsettings',
                label: <FormattedMessage id="entity-admin-appsetting-plural" />,
                children: [
                    { value: 'system-appsettings-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                    { value: 'system-appsettings-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                    { value: 'system-appsettings-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                    { value: 'system-appsettings-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                    {
                        value: 'system-appsettings-canRestoreDeleted',
                        label: <FormattedMessage id="authkeys-permission-canrestoredeleted" />
                    },
                    { value: 'system-appsettings-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> }
                ]
            },
            {
                value: 'system-codegeneratorsettings',
                label: <FormattedMessage id="entity-admin-codegeneratorsettings-plural" />,
                children: [
                    { value: 'system-codegeneratorsettings-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> },
                    { value: 'system-codegeneratorsettings-canView', label: <FormattedMessage id="authkeys-permission-canview" /> },
                    { value: 'system-codegeneratorsettings-canEdit', label: <FormattedMessage id="authkeys-permission-canedit" /> },
                    { value: 'system-codegeneratorsettings-canDelete', label: <FormattedMessage id="authkeys-permission-candelete" /> },
                    { value: 'system-codegeneratorsettings-canExport', label: <FormattedMessage id="authkeys-permission-canexport" /> }
                ]
            },
            {
                value: 'system-license',
                label: <FormattedMessage id="entity-admin-license-plural" />,
                children: [{ value: 'system-license-canAdd', label: <FormattedMessage id="authkeys-permission-canadd" /> }]
            }
        ]
    }
];

export default basePermissionTree;
